import React, { useContext, useEffect, useRef, useState } from 'react';
import { FaChevronDown } from 'react-icons/fa';
import styles from './styles/TopBar.module.css';
import AuthContext from '../../../context/AuthContext';
import NavbarMenu from '../../mainlayout/navbar/NavbarMenu';

/**
 * The editor's logo, doubling as the site menu. The editor replaces the navbar,
 * so this is the only way out to the rest of the site from here.
 *
 * No tutorial replay is offered: the only tour builds a brand-new scenario,
 * which is not something to start from inside another one.
 */
const TopBarMenu = () => {
    const { user } = useContext(AuthContext);

    const [showMenu, setShowMenu] = useState(false);
    const wrapperRef = useRef(null);

    useEffect(() => {
        if (!showMenu) return undefined;
        const handleClickOutside = (event) => {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                setShowMenu(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [showMenu]);

    return (
        <div className={styles.menuWrapper} ref={wrapperRef}>
            <button
                type="button"
                className={`${styles.logoButton} ${showMenu ? styles.logoButtonOpen : ''}`}
                onClick={() => setShowMenu((open) => !open)}
                aria-haspopup="menu"
                aria-expanded={showMenu}
                aria-label="Menu"
            >
                <img
                    className={styles.logo}
                    src={require('../../../images/logo_teal_background.png')}
                    alt=""
                />
                <FaChevronDown className={styles.logoCaret} aria-hidden="true" />
            </button>

            {showMenu && <NavbarMenu variant="topbar" setShowMenu={setShowMenu} user={user} />}
        </div>
    );
};

export default TopBarMenu;
